import React from 'react';

export function useBooleanState(initial = false): [boolean, () => void, () => void] {
    const [value, setValue] = React.useState(initial);
    const handleOn = React.useCallback(() => setValue(true), []);
    const handleOff = React.useCallback(() => setValue(false), []);
    return [value, handleOn, handleOff];
}
